<template>
    <modal name="clientSrchPopup" :width="850" :height="500" :clickToClose="false" @before-open="beforeOpen" @opened="opened">
        <div id="div_clientSrchPopup" class="popup on">
            <div class="pop_tit">
                거래처 조회
            </div>
            <!-- 탭 부분 -->
            <div id="div_clientSrchPopupScroll" class="scroll_area pop_con_wrap" style="height:450px;">
                <div class="tab_radio_wrap">
                    <div class="tab_radio">
                        <div class="custom-radio-02">
                            <input type="radio" id="atab01" name="tabs" class="radio" checked="checked" v-on:click="selectTabCode({'codeType':'AGENT_TYPE_CODE', 'codeValue':'10'})"><label for="atab01">대리점</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab02" name="tabs" class="radio" v-on:click="selectTabCode({'codeType':'AGENT_TYPE_CODE', 'codeValue':'20'})"><label for="atab02">B2B2C 매장</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab03" name="tabs" class="radio" v-on:click="selectTabCode({'codeType':'PARTNER_TYPE_CODE', 'codeValue':'50'})"><label for="atab03">카포스 연합</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab04" name="tabs" class="radio" v-on:click="selectTabCode({'codeType':'PARTNER_TYPE_CODE', 'codeValue':'40'})"><label for="atab04">스피드 메이트</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab05" name="tabs" class="radio" v-on:click="selectTabCode({'codeType':'PARTNER_TYPE_CODE', 'codeValue':'90'})"><label for="atab05">수리공장</label>
                        </div>
                    </div>
                </div>
                <!-- 검색 부분 -->
                <div class="pop_search_bg bgf7">
                    <div class="input-group-02">
                        <div class="colum-02 col-4">
                            <div class="form_box-02">
                                <label for="cus">거래처명</label>
                                <input type="text" id="cus" class="input-text" placeholder="현대하이카프라자" value="" autocomplete="off"
                                        v-model.lazy.trim="grid_options.general.params.clientName">
                            </div>
                        </div>
                        <div class="colum-02 col-4">
                            <div class="form_box-02">
                                <label for="code">거래처 코드</label>
                                <input type="text" id="code" class="input-text" placeholder="A123456789" value="" autocomplete="off"
                                        v-model.lazy.trim="grid_options.general.params.clientCode">
                            </div>
                        </div>
                        <div class="colum-02 col-1">
                            <div class="form_group">
                                <a href="javascript:void(0);" class="account_btn" @click="searchClient">검색</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 그리드 부분 -->
                <div class="pop_search_bg" style="height:280px;">
                    <div class="board_list type02">
                        <div class="sub_left_wrap">
                            <div class="btn_area mt0">
                                <a class="button white"><span>거래처 관리</span></a>
                            </div>
                            <div class="destxt vam ml10">
                                거래처의 <span>추가/수정/삭제</span> 마다 조정할 수 있습니다.
                            </div>
                        </div>
                        <grid :options="grid_options" v-once></grid>
                    </div>
                </div>
            </div>
            <!-- 푸터 부분 -->
            <div class="pop_footer_wrap">
                <div class="btn_area mt0">
                    <a href="javascript:void(0);" class="button blue" @click="sendClientData"><span>선택</span></a>
                </div>
            </div>
            <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
        </div>
    </modal>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'

export default {
    name : 'clientSrchPopup',
    components : { Grid, GridModule, Vue },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            //pushToParent: '',
            selectedTab : '',
            clientInfo : [],
            selectedCode : '',
            grid_options : {
                general : {
                  id  : 'client-srch-popup-grid',
                  search : '',  ///clientsrch/list
                  excel : false,    
                  type : {
                      isUpdate : false,
                      //isHideAdd : true : true,
                  },
                  params : {
                      clientName: '',
                      clientCode: '',
                      codeType: '',
                      codeValue: ''
                  }
                },
                grid_options : {
                    height: 216,
                    autoColumnIndex: true,
                    // rowindexColumnFromZero: false,
                    rowSelectOption:{
                        clickSelect: true,
                        singleSelect: true,
                        radioColumn: true,
                        allowSingleUnselect: false
                    },
                    paging: {
                        pagerTotal : false,
                        // hidePageList : false,
                        pagerSelect : false
                    },
                    
                    columnMapping : [
                        //{   key : 'brandId',          hidden: true },
                        //{   width : '30px',            selectorColumn : true   },
                        {   selectorColumn : true ,     title : '선택',           width : '46px', align : 'center' },
                        {   key : 'partnerId',          title : '코드',           width : '150px', align : 'center'  },
                        {   key : 'shopName',           title : '거래처명',      width : '150px', align : 'center'  },
                        {   key : 'registrationNumber', title : '사업자번호',      width : '170px', align : 'center'  },
                        {   key : 'presidentName',      title : '대표자',          width : '100px', align : 'center'  },
                        {   key : 'phoneNumber',        title : '전화번호',        width : '150px', align : 'center'  },
                        {   key : 'partnerNo',          hidden: true  },
                    ]
                }
            }
        }
    },
    created() {
        //alert("created");
    },
    mounted () {

    },
    methods : {
        beforeOpen(e) {
            //변수 초기화
            this.grid_options.general.search = '';
            this.clientInfo = [];
            this.selectedCode = '';
            this.grid_options.general.params.clientName = '';
            this.grid_options.general.params.clientCode = '';
            this.grid_options.general.params.codeType = 'AGENT_TYPE_CODE';
            this.grid_options.general.params.codeValue = '10';
        },
        opened(e) {
            //팝업창 닫기 관련 css 컨트롤(공통)
            $("#div_clientSrchPopup").parent().css('overflow', 'visible');
        },
        close() {
            //this.$emit('parts-code-search-slide-complete', {});
            this.$modal.hide('clientSrchPopup');
        },
        selectTabCode(tabName) {
            //탭 클릭할 경우 기존 검색파람 초기화
            this.selectedCode = '';
            this.grid_options.general.params.clientName = '';
            this.grid_options.general.params.clientCode = '';
            this.grid_options.general.params.codeValue = '';
            this.grid_options.general.params.codeType = '';

            //탭 클릭할 경우 기존 그리드 초기화
            $('#' + this.grid_options.general.id).alopexGrid('dataEmpty');
            //탭 클릭시 탭 코드 삽입
            this.selectedCode = tabName;
            //탭 클릭시 조회 구분 코드 삽입
            this.grid_options.general.params.codeValue = this.selectedCode.codeValue; //20 10 ..
            this.grid_options.general.params.codeType = this.selectedCode.codeType;   //AGENT_TYPE_CODE..
        },
        sendClientData(e) {
            //기존 선택된 데이터 초기화
            this.clientInfo = [];
            var data = '';

            var data = $('#' + this.grid_options.general.id).alopexGrid('dataGet', {_state: {selected:true}});
            if(data != null && data != undefined && data != '') {
                for(var key in data) {
                    this.clientInfo.push(data[key]);
                }
            }
            //거래처 한개 row를 다 보내는지?
            if(this.clientInfo != '' && this.clientInfo != undefined && this.clientInfo != null) {
                this.$emit('client-srch-popup-complete', {result: AlopexGrid.trimData(this.clientInfo[0])});
                this.$modal.hide('clientSrchPopup');
            } else {
                Vue.Alert.alert("담당자 항목 1개를 선택하시기 바랍니다");
                return false;
            }
        },
        searchClient() {
            this.grid_options.general.PageInfo.current = 1;
            this.grid_options.general.search = '/clientsrch/list';
            GridModule.searchData(this.grid_options);
        }

    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/ClientSrchPopup.vue